import React, { useState } from "react";
import {
  checkResponseData,
  checkErrorMessage,
} from "../../utils/responseHandler";
import { useToast, TOAST_TYPES } from "../../utils/toast";
import "./LoginForm.css";
import { loginApi, verifyGoogleApi, getRegisterTokenApi } from "../../services/authApi";
import { useGoogleLogin } from "@react-oauth/google";

const LoginForm = ({ onSwitchToRegister, onSwitchToForgot }) => {
  const [loginInfo, setLoginInfo] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const { showToast, ToastContainer } = useToast();
  const [showPassword, setShowPassword] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();

    if (!loginInfo.trim() || !password.trim()) {
      showToast("لطفا تمام فیلدها را پر کنید", TOAST_TYPES.WARNING);
      return;
    }

    setLoading(true);
    try {
      const response = await loginApi(loginInfo, password);
      const result = checkResponseData(response);

      if (result.success) {
        localStorage.setItem("token", result.token);
        localStorage.setItem("refreshToken", result.refreshToken);

        if (result.data && result.data.data && result.data.data[0]) {
          localStorage.setItem("userData", JSON.stringify(result.data.data[0]));
        }

        showToast(result.message || "ورود موفقیت‌آمیز", TOAST_TYPES.SUCCESS);
        setTimeout(() => window.location.reload(), 1500);
      } else {
        showToast(result.message || "خطا در ورود", TOAST_TYPES.ERROR);
      }
    } catch (error) {
      const errorDetails = checkErrorMessage(error);
      showToast(errorDetails.message, TOAST_TYPES.ERROR);
    } finally {
      setLoading(false);
    }
  };

  const googleLogin = useGoogleLogin({
    flow: "auth-code",
    onSuccess: async (codeResponse) => {
      try {
        const res = await verifyGoogleApi(codeResponse.code, "login");
        const data = res.data;
        if (data.rtoken === "notregisteredbefore") {
          showToast("شما هنوز ثبت نام نکرده‌اید. لطفاً ابتدا ثبت نام کنید.", TOAST_TYPES.WARNING);
          return;
        }
        const tokenRes = await getRegisterTokenApi(data.rtoken);
        if (tokenRes.data?.success) {
          showToast("ورود موفقیت‌آمیز", TOAST_TYPES.SUCCESS);
          setTimeout(() => window.location.reload(), 1500);
        }
      } catch (error) {
        const errorDetails = checkErrorMessage(error);
        showToast(errorDetails.message, TOAST_TYPES.ERROR);
      }
    },
    onError: () => {
      showToast("خطا در ورود با گوگل", TOAST_TYPES.ERROR);
    },
  });

  return (
    <>
      <ToastContainer />
      <form onSubmit={handleLogin}>
        <input
          type="text"
          className="auth-input"
          placeholder="ایمیل / شماره تلفن / نام کاربری"
          value={loginInfo}
          onChange={(e) => setLoginInfo(e.target.value)}
        />

        <div className="password-input-container">
          <input
            type={showPassword ? "text" : "password"}
            className="auth-input password-input"
            placeholder="رمز عبور"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <button
            type="button"
            className="password-toggle"
            onClick={() => setShowPassword(!showPassword)}
          >
            {showPassword ? "👁️" : "👁️‍🗨️"}
          </button>
        </div>
        <div style={{ textAlign: "left", marginBottom: "0.5rem" }}>
          <button
            type="button"
            onClick={onSwitchToForgot}
            className="auth-link"
            style={{ fontSize: "0.875rem" }}
          >
            رمز عبور را فراموش کرده‌اید؟
          </button>
        </div>
        <button type="submit" className="auth-button" disabled={loading}>
          {loading ? (
            <span
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "0.5rem",
              }}
            >
              <span className="loading-spinner"></span>
              در حال ورود...
            </span>
          ) : (
            "ورود به پلیر"
          )}
        </button>
        <div className="divider">
          <span>یا</span>
        </div>
        <button
          type="button"
          onClick={() => googleLogin()}
          className="google-button"
        >
          <svg width="20" height="20" viewBox="0 0 24 24">
            <path
              fill="#4285F4"
              d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
            />
            <path
              fill="#34A853"
              d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
            />
            <path
              fill="#FBBC05"
              d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
            />
            <path
              fill="#EA4335"
              d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
            />
          </svg>
          ورود با گوگل
        </button>
        <div style={{ marginTop: "0.75rem", textAlign: "center" }}>
          <span style={{ color: "#8a9bb5" }}>حساب کاربری ندارید؟ </span>
          <button
            type="button"
            onClick={onSwitchToRegister}
            className="auth-link"
          >
            ثبت نام
          </button>
        </div>
      </form>
    </>
  );
};

export default LoginForm;
